"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentTabItem = void 0;
var React = require("react");
var Tabs_styles_1 = require("./../Tabs.styles");
var ContentTabItem = function (_a) {
    var TabPanelId = _a.TabPanelId, Caption = _a.Caption, IsActive = _a.IsActive, IsFocused = _a.IsFocused, OnClick = _a.OnClick, OnKeyDown = _a.OnKeyDown;
    var tabRef = React.useRef();
    React.useEffect(function () {
        if (IsFocused) {
            tabRef.current.focus();
        }
    }, [IsFocused]);
    return (React.createElement("li", { role: "presentation" },
        React.createElement(Tabs_styles_1.Button, { ref: tabRef, role: "tab", type: "button", "aria-selected": IsActive, "aria-controls": "" + TabPanelId, tabIndex: IsActive ? 0 : -1, onClick: OnClick, onKeyDown: function (e) { return OnKeyDown(e); } }, Caption)));
};
exports.ContentTabItem = ContentTabItem;
